//
import { useHistory, useParams } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Tabs,
  Tab,
  Button,
  useMediaQuery,
  Theme,
  useTheme,
  alpha
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
// components
import Grid from '@material-ui/core/Grid';
import { TabContext, TabPanel } from '@material-ui/lab';
import { Icon } from '@iconify/react';
import useConfig from '../hooks/useConfig';
import Page from '../components/Page';
import { APIStatus } from '../@types/APIStatus';
import { useOrderStyles } from '../components/order/styles';
import { textStyles } from '../theme/TextClasses';
import HeaderWidget from '../components/order/HeaderWidget';
import useAcsMessageDetail from '../hooks/acs/useAcsMessageDetail';
import AcsMessageRows from '../components/acs/acsMessageDetailTabs/AcsMessageRows';
import useAcsMessages from '../hooks/acs/useAcsMessages';
import { AcsMessagesRow } from '../@types/tableRows';
import { CompanyLogo } from '../components/general/CompanyLogo';
import { unknownToNumber } from '../utils/helper';
import useLocales from '../hooks/useLocales';
import ActionButton from '../components/acs/messages/ActionButton';
import AcsMessagesLogDialog from '../components/acs/messages/AcsMessagesLogDialog';

import useFilters from '../hooks/useFilters';

export default function ACSMessage() {
  const { id } = useParams<{ id: string }>();
  const theme = useTheme();
  const { currentLang } = useLocales();
  const classes = useOrderStyles();
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );
  const history = useHistory();
  const textClasses = textStyles({});
  const tabsRef = useRef<HTMLDivElement>(null);
  const [tabSelected, setTabSelected] = useState<string>('0');

  const [messageState, setMessageState] = useState<AcsMessagesRow | undefined>(
    undefined
  );
  const [showLogs, setShowLogs] = useState(false);

  const {
    APIStatus: state,
    getAcsMessageDetail,
    response: { messageId, messageName, f1, f2, f3 }
  } = useAcsMessageDetail();

  const {
    response: {
      acsFilters: { acsEdiDocumentTypes: acsEdiDocumentTypesList }
    }
  } = useFilters();

  const { getMessageByMessageId } = useAcsMessages();

  const { config } = useConfig();
  const { t: translate } = useTranslation(['menu', 'component']);

  useEffect(() => {
    // getAcsMessageDetail(id);
    const msg_local = getMessageByMessageId(parseInt(id, 10));
    console.log(msg_local);
    /* if (!msg_local) {
      getAcsMessages(
        `messageId=${id}`,
        { by: 'message', order: 'desc' },
        { skip: 0, limit: 1 }
      )
    } */
    setMessageState(msg_local);
  }, [id]);

  if (state === APIStatus.REJECTED || !messageState) {
    return <div>{`No message found with ID: ${id}`}</div>;
  }

  const formatter = new Intl.DateTimeFormat(currentLang.value);
  const formattedDate = formatter.format(new Date(messageState.date));
  const getColor = (status: string): string => {
    switch (status) {
      case 'ERROR':
        return theme.palette.error.main;
      case 'WARNING':
        return theme.palette.warning.main;
      case 'FINISH':
        return theme.palette.success.main;
      case 'INFO':
        return theme.palette.info.main;
      default:
        return theme.palette.text.secondary;
    }
  };

  const textColor = getColor(messageState.transactionStatus);
  const backgroundColor = alpha(textColor, 0.1);
  const dType_t = messageState.documentType;
  const dType = acsEdiDocumentTypesList.find(
    (tp) => String(tp.extra) === dType_t
  );

  return (
    <Page title={`${config.company} - ${translate('order')}`}>
      <Container maxWidth="xl" sx={{ marginTop: '8px' }}>
        <Grid container spacing={4}>
          <Grid container item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid item xs={12}>
                  <Button variant="text" onClick={() => history.goBack()}>
                    {translate('global:backLabel')}
                  </Button>
                </Grid>
                <Paper variant="outlined" className={classes.container}>
                  <Grid container item xs={12} spacing={2}>
                    <Grid
                      container
                      justifyContent="space-around"
                      alignItems="center"
                      item
                      xs={5}
                      md={3}
                    >
                      <Grid item>
                        <CompanyLogo
                          id={unknownToNumber(
                            messageState.tradingPartnerIDFrom
                          )}
                          name=""
                          size={96}
                        />
                      </Grid>

                      <Grid item>
                        <Icon
                          icon="eva:arrow-forward-fill"
                          width={42}
                          height={42}
                          color={theme.palette.info.main}
                        />
                      </Grid>

                      <Grid item>
                        <CompanyLogo
                          id={unknownToNumber(messageState.tradingPartnerIDTo)}
                          name=""
                          size={96}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={7}
                      md={6}
                      className={classes.description}
                      paddingBottom={2}
                    >
                      <Grid container item xs={12}>
                        <Grid item xs={6} md={4}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={500}
                            color="text.primary"
                          >
                            {translate('filter:trading_partner')}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={8}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={700}
                            color="text.primary"
                          >
                            {messageState.tradingPartnerName}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container item xs={12}>
                        <Grid item xs={6} md={4}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={500}
                            color="text.primary"
                          >
                            {translate('component:job_name')}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={8}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={700}
                            color="text.primary"
                          >
                            {messageState.jobName ?? '-'}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container item xs={12}>
                        <Grid item xs={6} md={4}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={500}
                            color="text.primary"
                          >
                            {translate('component:message_id')}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} md={8}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={700}
                            color="text.primary"
                          >
                            {messageState.messageId}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container item xs={12}>
                        <Grid item xs={6} md={4}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={500}
                            color="text.primary"
                          >
                            {translate('component:job_id')}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={8}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={700}
                            color="text.primary"
                          >
                            {messageState.jobId}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container item xs={12}>
                        <Grid item xs={6} md={4}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={500}
                            color="text.primary"
                          >
                            {translate('component:date')}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={8}>
                          <Typography
                            variant={isMobile ? 'body1' : 'h6'}
                            fontWeight={700}
                            color="text.primary"
                          >
                            {formattedDate}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      container
                      flexDirection="column"
                      justifyContent="space-around"
                      xs={12}
                      md={3}
                    >
                      <Grid item>
                        <ActionButton
                          icon="ix:log"
                          title={translate('component:show_log')}
                          onClick={() => setShowLogs(true)}
                        />
                      </Grid>
                      {messageState.sourceFileLink &&
                        messageState.sourceFileLink.length > 0 && (
                          <Grid item>
                            <ActionButton
                              title={translate(
                                'component:download_source_file'
                              )}
                              icon="uil:file-download-alt"
                              href={messageState.sourceFileLink}
                              target="_blank"
                            />
                          </Grid>
                        )}
                      {messageState.deployFileLink &&
                        messageState.deployFileLink.length > 0 && (
                          <Grid item>
                            <ActionButton
                              title={translate(
                                'component:download_deployed_file'
                              )}
                              icon="material-symbols:deployed-code-update-outline"
                              href={messageState.deployFileLink}
                              target="_blank"
                            />
                          </Grid>
                        )}
                    </Grid>

                    <Grid container item xs={12} className={classes.widgetRoot}>
                      <Grid
                        container
                        item
                        xs={12}
                        spacing={2}
                        className={classes.widgetContainer}
                      >
                        <Grid item xs={12} sm={6} lg={3}>
                          <HeaderWidget title={translate('component:gln')}>
                            <Grid
                              container
                              spacing={2}
                              flexDirection="column"
                              justifyContent="center"
                              alignItems="center"
                              paddingTop={3}
                            >
                              {messageState.primaryId && (
                                <Grid item>
                                  <Typography
                                    variant="body1"
                                    fontWeight={500}
                                    textAlign="start"
                                    className={textClasses.ellipsis}
                                  >
                                    {translate('component:primary_id')}:{' '}
                                    <b>{messageState.primaryId}</b>
                                  </Typography>
                                </Grid>
                              )}
                              {messageState.sendingGln && (
                                <Grid item>
                                  <Typography
                                    variant="body1"
                                    fontWeight={500}
                                    textAlign="start"
                                    className={textClasses.ellipsis}
                                  >
                                    {translate('component:sending_gln')}:{' '}
                                    <b>{messageState.sendingGln}</b>
                                  </Typography>
                                </Grid>
                              )}
                              {messageState.receivingGln && (
                                <Grid item>
                                  <Typography
                                    variant="body1"
                                    fontWeight={500}
                                    textAlign="start"
                                    className={textClasses.ellipsis}
                                  >
                                    {translate('component:receiving_gln')}:{' '}
                                    <b>{messageState.receivingGln}</b>
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </HeaderWidget>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                          <HeaderWidget
                            title={translate('component:transaction_status')}
                          >
                            <Box className={`${classes.centerBox} column`}>
                              <Box
                                onClick={() => {
                                  setShowLogs(true);
                                }}
                                sx={{
                                  display: 'inline-block',
                                  px: 2,
                                  py: 1,
                                  borderRadius: 1,
                                  bgcolor: backgroundColor,
                                  color: textColor,
                                  cursor: 'pointer',
                                  userSelect: 'none',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    bgcolor: alpha(textColor, 0.15),
                                    transform: 'scale(1.02)'
                                  },
                                  '&:active': {
                                    transform: 'scale(0.98)'
                                  }
                                }}
                              >
                                <Typography variant="body2" fontWeight={500}>
                                  {messageState.transactionStatus}
                                </Typography>
                              </Box>
                            </Box>
                          </HeaderWidget>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={3}>
                          <HeaderWidget
                            title={translate('component:document_type')}
                          >
                            <Box className={`${classes.centerBox} column`}>
                              <Typography
                                variant="subtitle1"
                                fontWeight={700}
                                color="text.primary"
                              >
                                {dType?.name ?? '-'}
                              </Typography>
                            </Box>
                          </HeaderWidget>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={3}>
                          <HeaderWidget
                            title={translate('component:direction')}
                          >
                            <Box className={`${classes.centerBox} column`}>
                              <Typography variant="subtitle1">
                                {messageState.direction !== 'IN'
                                  ? 'OUT'
                                  : messageState.direction}
                              </Typography>
                            </Box>
                          </HeaderWidget>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          <Grid container item xs={12}>
            <TabContext value={tabSelected}>
              <Box
                className={classes.boxContainer}
                component="div"
                ref={tabsRef}
              >
                <Tabs
                  className={classes.tabs}
                  variant="scrollable"
                  scrollButtons="auto"
                  value={tabSelected}
                  onChange={(e, v) => setTabSelected(v)}
                  aria-label="Message detail tabs"
                >
                  <Tab
                    className={classes.tab}
                    label={translate('messages')}
                    value="0"
                  />
                  <Tab
                    className={classes.tab}
                    label={translate('timeline')}
                    value="1"
                  />
                </Tabs>
              </Box>
              <Paper className={classes.tabContainer} variant="outlined">
                <Typography
                  variant="h5"
                  className={`${textClasses.ellipsis} ${classes.tabTitle}`}
                >
                  <AcsMessageRows />
                </Typography>

                <TabPanel value="0">
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {/* <OrderArticles /> */}
                    </Grid>
                  </Grid>
                </TabPanel>

                <TabPanel value="1">
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {/* <OrderTimeline /> */}
                    </Grid>
                  </Grid>
                </TabPanel>
              </Paper>
            </TabContext>
          </Grid>
        </Grid>
      </Container>
      <AcsMessagesLogDialog
        messageId={messageState.messageId}
        isOpen={showLogs}
        onCloseModal={() => setShowLogs(false)}
      />
    </Page>
  );
}
